export default "__VITE_ASSET__CFW9f0cu__"